import {
  Drawer,
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Remember to import a clean close icon
import { Colors } from "../../../styles/theme";
import { LOGIN_NAV_LINKS, NAV_LINKS } from "../utils/utils";
import NavLinks from "./NavLinks";
import LanguageSwitcher from "./LanguageSwitcher";
import React from "react";

function NavMobile({ open, onClose, auth, currentLang }) {
  const { logout, isLoggingOut, isLoggedIn } = auth;
  const logoutText = isLoggingOut ? " جاري تسجيل الخروج ..." : "تسجيل الخروج";
  // const isRtl = currentLang === "ar";
  const isRtl = true;

  return (
    <Drawer
      anchor={isRtl ? "right" : "left"} // Automatically shifts sides based on layout direction
      open={open}
      onClose={onClose}
      sx={{ zIndex: 9999 }}
      PaperProps={{
        sx: {
          width: { xs: "80%", sm: "320px" }, // Professional mobile width constraints
          backgroundColor: "#fff",
          height: "100vh",
          boxShadow: isRtl
            ? "4px 0px 20px rgba(0, 0, 0, 0.15)"
            : "-4px 0px 20px rgba(0, 0, 0, 0.15)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* 1. Header Section with Brand Title/Logo & Dismiss X Button */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #f0f0f0",
          flexDirection: isRtl ? "row-reverse" : "row",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: Colors.color1 || "#111" }}
        >
          {isRtl ? "القائمة" : "Menu"}
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: "#666" }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* 2. Scrollable Body Content */}
      <Box
        role="presentation"
        sx={{
          overflowY: "auto",
          flexGrow: 1,
          padding: "16px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {/* Main Links Area */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <NavLinks links={NAV_LINKS} onClick={onClose} isRtl={isRtl} />
        </Box>

        {/* Auth Section with clean layout separation */}
        {isLoggedIn && (
          <>
            <Divider sx={{ margin: "12px 0", borderColor: "#f0f0f0" }} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <NavLinks
                links={LOGIN_NAV_LINKS}
                onClick={onClose}
                isRtl={isRtl}
              />
            </Box>

            <Button
              fullWidth
              variant="contained"
              onClick={logout}
              sx={{
                marginTop: "auto",
                backgroundColor: "#ff4d4f", // Clean, explicit destructive state color
                color: "#fff",
                padding: "10px",
                borderRadius: "8px",
                boxShadow: "none",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#e03e41",
                  boxShadow: "none",
                },
              }}
            >
              {logoutText}
            </Button>
          </>
        )}
      </Box>

      {/* 3. Dedicated Fixed Footer Box for the Language Switcher */}
      <Box
        sx={{
          padding: "16px 20px 40px",
          borderTop: "1px solid #f0f0f0",
          backgroundColor: "#fcfcfc",
          display: "flex",
          alignItems: "center",
          justifyContent: isRtl ? "flex-start" : "flex-end",
        }}
      >
        <LanguageSwitcher />
      </Box>
    </Drawer>
  );
}
export default React.memo(NavMobile);
